import { submitIdpOtp } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  SubmitIDPOTPRequestT,
  DosespotIDPRecordT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';
import { logger } from '@/shared';

/**
 * Submit OTP for IDP verification.
 */
export async function fetchSubmitIdpOtp(
  data: SubmitIDPOTPRequestT,
  signal?: AbortSignal
): Promise<DosespotIDPRecordT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await submitIdpOtp(data, config);
  const result = lotusHealthZod.submitIdpOtpResponse.parse(response.data) as DosespotIDPRecordT;

  logger.info('dosespot.idp.submitOtp', {
    source: 'entities/dosespot-idp/api',
    currentState: result.current_state,
  });

  return result;
}
